/**
 * Wipe browser-persisted session data for a clean sign-out.
 * Clears MSAL caches, app storage, and Cache Storage entries.
 */
export async function clearAllBrowserData() {
    try {
        sessionStorage.clear();
    }
    catch {
        /* ignore */
    }
    try {
        localStorage.clear();
    }
    catch {
        /* ignore */
    }
    try {
        if (typeof caches !== 'undefined') {
            const keys = await caches.keys();
            await Promise.all(keys.map((k) => caches.delete(k)));
        }
    }
    catch {
        /* ignore */
    }
    try {
        if (typeof indexedDB !== 'undefined' && indexedDB.databases) {
            const dbs = await indexedDB.databases();
            await Promise.all((dbs || []).map((db) => new Promise((resolve) => {
                if (!db.name) {
                    resolve();
                    return;
                }
                const req = indexedDB.deleteDatabase(db.name);
                req.onsuccess = () => resolve();
                req.onerror = () => resolve();
                req.onblocked = () => resolve();
            })));
        }
    }
    catch {
        /* ignore */
    }
}
